import { SectionHeader } from '@core/components';
import { Heading, Text } from '@soteria/design-system-ve';

import * as styles from './TraitsSection.css';

/**
 * Traits section component for use within tabs
 * Displays traits management without page-level wrapper (no HeroBackground or Container)
 *
 * Currently stubbed - will be implemented when traits API is integrated
 */
export function TraitsSection() {
  return (
    <>
      <SectionHeader description="Configure moderation traits that can be applied to content during moderation actions." title="Moderation Traits" />

      <div className={styles.emptyState}>
        <div>
          <Heading level="h3">Moderation Traits</Heading>
          <Text className={styles.emptyStateText}>No API Integration</Text>
          <Text className={styles.emptyStateDescription}>
            Traits management will be available once the traits API is integrated. Traits are moderation labels that can be applied to content during review.
          </Text>
        </div>
      </div>
    </>
  );
}
